import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  MixedWidget4,
  StatsWidget11,
  MixedWidget6
  // StatsWidget12,
  // StatsWidget10,
  // ListsWidget14,
} from "../widgets";
import { StatsWidget13 } from "../widgets/stats/StatsWidget13";
import * as actions from "../../../app/actions/generalActions";
import { ObjectsLoadingDialog } from "../../layout/components/basePage/pages/objects-loading-dialog/ObjectsLoadingDialog";
import { LoadingDialog } from "../controls";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";


export function DormitoryDashboard() {

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/dorm/dormDashboard")) {
    const temp = menuList.find(q => q.url == "/dorm/dormDashboard")
    isFullAccess = temp.isFullAccess;
  }



  const [dormTitles, setDormTitles] = useState(null)
  const [allData, setAllData] = useState([])

  const [usersActiveCount, setUsersActiveCount] = useState([])
  const [totalActiveCount, setTotalActiveCount] = useState(0)

  const [usersPresentCount, setUsersPresentCount] = useState([])
  const [totalPresentCount, setTotalPresentCount] = useState(0)

  const [usersAbsentCount, setUsersAbsentCount] = useState([])
  const [totalAbsentCount, setTotalAbsentCount] = useState(0)

  const [usersAbsentjustify, setUsersAbsentjustify] = useState([])
  const [totalAbsentjustify, setTotalAbsentjustify] = useState(0)

  const [usersNotTrafficToday, setUsersNotTrafficToday] = useState([])
  const [totalNotTrafficToday, setTotalNotTrafficToday] = useState(0)

  const [usersPresentMore3Days, setUsersPresentMore3Days] = useState([])
  const [totalPresentMore3Days, setTotalPresentMore3Days] = useState(0)

  const [usersAbsentmore3Days, setUsersAbsentmore3Days] = useState([])
  const [totalAbsentmore3Days, setTotalAbsentmore3Days] = useState(0)

  const [capacity, setCapacity] = useState([])
  const [totalCapacity, setTotalCapacity] = useState(0)

  const [emptyCapacity, setEmptyCapacity] = useState([])
  const [totalEmptyCapacity, setTotalEmptyCapacity] = useState(0)

  const { currentState, name, entities, listLoading } = useSelector(
    (state) => ({
      currentState: state.baseInfo.dormDashboard,
      name: state.baseInfo.dormDashboard.name,
      listLoading: state.baseInfo.dormDashboard.listLoading,
      entities: state.baseInfo.dormDashboard.entities
    }),
    shallowEqual
  );

  const intl = useIntl();
  const history = useHistory();

  const dispatch = useDispatch();
  useEffect(() => {
    if (isFullAccess) {
      const query = {
        whereClause: "",
        whereClauseParameters: [],
        orderClause: "id asc ",
        skipCount: 0,
        takeCount: 1000,
      };
      // dispatch(actions.fetchObjects("forceEmpty", name, query))
      dispatch(actions.fetchSpReports("api/user", name, query, "GetDormitoryDashboardReport"))
    }
    else {
      history.push("/dorm/myReservation")
    }

  }, [isFullAccess]);

  useEffect(() => {
    if (entities) {
      setAllData([...entities])

      setTotalActiveCount(entities[0].userActive)
      setTotalPresentCount(entities[0].userPresent)
      setTotalAbsentCount(entities[0].userAbsent)
      setTotalAbsentjustify(entities[0].userAbsentJustify)
      setTotalNotTrafficToday(entities[0].userNotTrafficToday)
      setTotalPresentMore3Days(entities[0].userPresentMore3Day)
      setTotalAbsentmore3Days(entities[0].userAbsentMore3Day)
      setTotalCapacity(entities[0].capacity)
      setTotalEmptyCapacity(entities[0].emptyCapacity)

      setUsersActiveCount(entities.filter(q => q.id !== 1).map(a => a.userActive))
      setUsersPresentCount(entities.filter(q => q.id !== 1).map(a => a.userPresent))
      setUsersAbsentCount(entities.filter(q => q.id !== 1).map(a => a.userAbsent))
      setUsersAbsentjustify(entities.filter(q => q.id !== 1).map(a => a.userAbsentJustify))
      setUsersNotTrafficToday(entities.filter(q => q.id !== 1).map(a => a.userNotTrafficToday))
      setUsersPresentMore3Days(entities.filter(q => q.id !== 1).map(a => a.userPresentMore3Day))
      setCapacity(entities.filter(q => q.id !== 1).map(a => a.capacity))
      setEmptyCapacity(entities.filter(q => q.id !== 1).map(a => a.emptyCapacity))

      setDormTitles([...entities.filter(q => q.id !== 1).map(a => a.dormTitle)])
    }
  }, [entities]);


  return (
    <>
      {/* begin::Dashboard */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-xl-4">
          <MixedWidget6 className="gutter-b card-stretch" />
        </div>
        <div className="col-xl-8">
          <BaseTablesWidget6 className="gutter-b" />
        </div>
      </div> */}
      {/* end::Row */}

      {/* begin::Row */}
      {isFullAccess && <ObjectsLoadingDialog listLoading={listLoading} />}
      {isFullAccess && dormTitles && dormTitles.length > 0 &&
        <div className="row">
          <div className="col-xl-6">
            <MixedWidget4
              className="gutter-b  card-stretch"
              symbolShape="circle"
              chartColor="primary"
              title=" ظرفیت خوابگاه "
              chartId="dorm_dashboard_capacity_chart"
              data={capacity}
              labels={dormTitles}
              totalCount={totalCapacity}
              iconUrl="/media/svg/icons/Layout/Layout-4-blocks.svg"
              showAll={false}
              maxValue={2000}
              customColor="#baca4f"
            />
          </div>




          <div className="col-xl-6">
            <MixedWidget4
              className="gutter-b  card-stretch"
              symbolShape="circle"
              chartColor="primary"
              title=" تعداد ساکنین خوابگاه "
              chartId="dorm_dashboard_active_chart"
              data={usersActiveCount}
              labels={dormTitles}
              totalCount={totalActiveCount}
              iconUrl="/media/svg/icons/Layout/Layout-4-blocks.svg"
              showAll={false}
              maxValue={200}
            />
          </div>
          <div className="col-xl-6">
            <MixedWidget4
              className="gutter-b  card-stretch"
              symbolShape="circle"
              chartColor="primary"
              title=" ظرفیت خالی خوابگاه  "
              chartId="dorm_dashboard_emptyCapacity_chart"
              data={emptyCapacity}
              labels={dormTitles}
              totalCount={totalEmptyCapacity}
              iconUrl="/media/svg/icons/Layout/Layout-4-blocks.svg"
              showAll={false}
              maxValue={2000}
              customColor="#001a66"
            />
          </div>
          <div className="col-xl-3">
            <MixedWidget4
              className="gutter-b  card-stretch"
              symbolShape="circle"
              chartColor="primary"
              title=" حاضرین "
              chartId="dorm_dashboard_present_chart"
              data={usersPresentCount}
              labels={dormTitles}
              totalCount={totalPresentCount}
              customColor="#0acc4b"
            />
          </div>
          <div className="col-xl-3">
            <MixedWidget4
              className="gutter-b"
              symbolShape="circle"
              chartColor="primary"
              title=" غائبین "
              chartId="dorm_dashboard_absent_chart"
              data={usersAbsentCount}
              labels={dormTitles}
              totalCount={totalAbsentCount}
              customColor="#e7403a"
            />
          </div>
          <div className="col-xl-3">
            <MixedWidget4
              className="gutter-b"
              symbolShape="circle"
              chartColor="primary"
              title=" غائبین موجه "
              chartId="dorm_dashboard_absentJustify_chart"
              data={usersAbsentjustify}
              labels={dormTitles}
              totalCount={totalAbsentjustify}
              customColor="#07b8e4"
            />
          </div>
          <div className="col-xl-3">
            <MixedWidget4
              className="gutter-b"
              symbolShape="circle"
              chartColor="primary"
              title=" امروز تردد نداشته اند "
              chartId="dorm_dashboard_notTraffic_chart"
              data={usersNotTrafficToday}
              labels={dormTitles}
              totalCount={totalNotTrafficToday}
              customColor="#F1AE15"
            />
          </div>
          <div className="col-xl-3">
            <MixedWidget4
              className="gutter-b"
              symbolShape="circle"
              chartColor="primary"
              title=" بیش از 3 روز حاضر "
              chartId="dorm_dashboard_3MorePresent_chart"
              data={usersPresentMore3Days}
              labels={dormTitles}
              totalCount={totalPresentMore3Days}
              customColor="#4A7DFF"
            />
          </div>
          <div className="col-xl-3">
            <MixedWidget4
              className="gutter-b"
              symbolShape="circle"
              chartColor="primary"
              title=" بیش از 3 روز غائب "
              chartId="dorm_dashboard_3MoreAbsent_chart"
              data={usersAbsentmore3Days}
              labels={dormTitles}
              totalCount={totalAbsentmore3Days}
              customColor="#b121ce"
            />
          </div>
          <div className="col-xl-12">
            <MixedWidget6
              className="gutter-b"
              symbolShape="circle"
              chartColor="primary"
              title=" گزارش کلی "
              chartId="dorm_dashboard_All_chart"
              // currentState={currentState}
              fullData={allData}
              dataActive={usersActiveCount}
              dataPresent={usersPresentCount}
              dataAbsent={usersAbsentCount}
              totalAbsent={totalAbsentCount}
              dataJustify={usersAbsentjustify}
              dataNotActive={usersNotTrafficToday}
              dataMore3Present={usersPresentMore3Days}
              dataMore3Absent={usersAbsentmore3Days}
              dataCapacity={capacity}
              dataEmptyCapacity={emptyCapacity}
              labels={dormTitles}
              totalCount={totalActiveCount}
              iconUrl="/media/svg/icons/Layout/Layout-4-blocks.svg"
              showAll={false}
              maxValue={200}
            />
          </div>

          {/* <div className="col-xl-4">
          <MixedWidget4
            className="gutter-b card-stretch"
            title=" تعداد ساکنین خوابگاه "
            chartId="dorm_dashboard_active2_chart"
            data={usersActiveCount}
            labels={dormTitles}
            totalCount={totalActiveCount}
            iconUrl="/media/svg/icons/Layout/Layout-4-blocks.svg"
          />
        </div> */}
          {/* <div className="col-xl-3">
          <StatsWidget10
            className="gutter-b"
            symbolShape="circle"
            baseColor="dark"
            title=" غائبین "
          />
        </div>
        <div className="col-xl-3">
          <StatsWidget13
            className="gutter-b"
            symbolShape="circle"
            baseColor="dark"
            title=" افرادی که امروز تردد نداشته اند "
          />
        </div> */}

        </div>
      }
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-lg-12 col-xxl-12">
          <AdvanceTablesWidget9 className="card-stretch gutter-b" />
        </div>
      </div> */}
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-xl-6">
          <ListsWidget10 className="card-stretch gutter-b" />
        </div>
        <div className="col-xl-6">
          <BaseTablesWidget1 className="card-stretch gutter-b" />
        </div>
      </div> */}
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-lg-4">
          <ListsWidget8 className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-8">
          <BaseTablesWidget2 className="card-stretch gutter-b" />
        </div>
      </div> */}
      {/* end::Row */}

      {/* end::Dashboard */}
    </>
  );
}
